import styled, { css, keyframes } from 'styled-components'

export type AnimationProps = {
  type: keyof typeof types
  infinite?: boolean
  easing?: string
  duration: number
  active?: boolean
}

export const Animation = styled.div<AnimationProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  animation: ${({ type, infinite, easing = 'linear', duration, active = true }) =>
    active
      ? css`
          ${types[type]} ${duration}s ${easing}  ${infinite ? 'infinite' : ''}
        `
      : ``};
`

const types = {
  'rotate-cw': keyframes`
      from {
        transform: rotate(0deg);
      }
    
      to {
        transform: rotate(360deg);
      }
    `,
  hearthbeat: keyframes`
    from {
      transform: scale(1);
      transform-origin: center center;
      animation-timing-function: ease-out;
    }
    10% {
      transform: scale(0.91);
      animation-timing-function: ease-in;
    }
    17% {
      transform: scale(0.98);
      animation-timing-function: ease-out;
    }
    33% {
      transform: scale(0.87);
      animation-timing-function: ease-in;
    }
    45% {
      transform: scale(1);
      animation-timing-function: ease-out;
    }
  `,
  'flip-x': keyframes``,
  blink: keyframes`
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  `,
  'appear-from-left': keyframes`
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0)
    }
  `,
  'dissapear-to-left': keyframes`
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%)
    }
  `
}
